module.exports = __webpack_public_path__ + "img/Association_VPA_3.64ee655f.jpg";